import React, { useState } from "react";

const instructionsSections = [
  {
    type: "heading",
    text: "How to Play",
  },
  {
    type: "list",
    items: [
      "Each guess must be a valid five-letter word.",
      <>
        The color of a tile will change to show you how close your guess was:
        <ul
          style={{ margin: 0, marginTop: 4, marginBottom: 8, paddingLeft: 20 }}
        >
          <li>
            <span style={{ color: "green", fontWeight: "bold" }}>Green</span>{" "}
            means the letter is in the word and in the right spot.
          </li>
          <li>
            <span style={{ color: "goldenrod", fontWeight: "bold" }}>
              Yellow
            </span>{" "}
            means the letter is in the word but in the wrong spot.
          </li>
          <li>
            <span style={{ color: "gray", fontWeight: "bold" }}>Gray</span>{" "}
            means the letter is not in the word.
          </li>
        </ul>
      </>,
      "After loading the webpage, select the dialect you want to use.",
      "After finishing a game, you can select New Game or simply change the dialect to start another round.",
      'The rules for this game currently only operate in "easy mode": previous guesses do not limit which letters you can use in subsequent guesses.',
    ],
  },
  {
    type: "divider",
  },
  {
    type: "heading",
    text: "Important notes about the words:",
  },
  {
    type: "list",
    items: [
      "The data comes from The Living Arabic Project's dictionaries and focuses on headwords, not example sentences.",
      "So you won't find every morphological possibility of words.",
      <>
        For instance, for nouns and adjectives, you won't find words with the
        definite article or pronoun suffixes (like{" "}
        <span dir="rtl" lang="ar">
          <b>العمل</b> أو <b>عملهم</b>
        </span>
        ).
      </>,
      "The Classical, Levantine, Maghrebi, and Egyptian word lists have more words than the other dialects.",
    ],
  },
];

function InstructionsButton({
  title = "Instructions",
  sections = instructionsSections,
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        style={{
          padding: "0.5rem 1rem",
          backgroundColor: "#00274C",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        onClick={() => setOpen(true)}
      >
        Show Instructions
      </button>

      {open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            dir="ltr"
            style={{
              background: "#fff",
              padding: "1.5rem",
              borderRadius: "10px",
              width: "400px",
              maxWidth: "95vw",
              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
              position: "relative",
              maxHeight: "75vh", // limit height
              overflowY: "auto", // scroll if needed
            }}
          >
            <button
              aria-label="Close instructions"
              onClick={() => setOpen(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                border: "none",
                background: "none",
                fontSize: "1.2rem",
                fontWeight: "bold",
                color: "#888",
                cursor: "pointer",
              }}
            >
              ×
            </button>
            <h2
              style={{
                marginTop: 0,
                marginBottom: "1em",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              {title}
            </h2>
            <div style={{ textAlign: "left" }} dir="ltr">
              {sections.map((section, i) => {
                if (section.type === "heading") {
                  return (
                    <h3
                      key={i}
                      style={{
                        marginBottom: "0.5em",
                        marginTop: i > 0 ? "1.2em" : 0,
                      }}
                    >
                      {section.text}
                    </h3>
                  );
                }
                if (section.type === "list" && Array.isArray(section.items)) {
                  return (
                    <ol
                      key={i}
                      style={{ marginLeft: "1.5em", marginBottom: "1em" }}
                    >
                      {section.items.map((item, j) => (
                        <li key={j} style={{ marginBottom: 6 }}>
                          {item}
                        </li>
                      ))}
                    </ol>
                  );
                }
                if (section.type === "divider") {
                  return <hr key={i} style={{ margin: "1.4em 0" }} />;
                }
                return null;
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default InstructionsButton;
